import { FC } from 'react';

export const Brand: FC = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 207 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24656_7342)">
        <path
          d="M138.683 59.5411C144.413 59.5411 148.664 57.2986 151.619 53.6349L146.482 49.0855C144.002 51.3883 141.816 52.3345 138.804 52.3345C134.79 52.3345 131.952 50.2087 131.066 46.1344H153.097C153.153 45.305 153.213 44.4797 153.213 43.7711C153.213 34.7931 148.37 26.584 137.798 26.584C128.582 26.584 122.145 34.0241 122.145 43.0625C122.145 52.8659 129.174 59.5411 138.683 59.5411ZM130.949 40.5221C131.658 36.4478 134.078 33.7906 137.802 33.7906C141.526 33.7906 143.945 36.5081 144.477 40.5221H130.949Z"
          fill="#003399"
        />
        <path
          d="M119.733 44.343V15.7139H110.755V28.9957C99.7238 21.7046 86.4822 29.8493 86.4822 42.9419C86.4822 49.9955 89.542 54.867 93.7451 57.3953C103.665 63.37 118.948 58.3978 119.737 44.343M103.194 51.8032C98.9991 51.8032 95.4562 48.3167 95.4562 43.0627C95.4562 37.8087 98.9991 34.2054 103.194 34.2054C107.389 34.2054 110.872 37.6879 110.872 42.9459C110.872 48.2039 107.385 51.8072 103.194 51.8072V51.8032Z"
          fill="#003399"
        />
        <path
          d="M64.5203 58.8321H73.4983V47.1365C73.4983 39.5757 77.162 35.9724 83.1245 35.9724H83.5996V26.5796C71.9644 26.0643 64.5243 36.9708 64.5243 44.109V58.8281L64.5203 58.8321Z"
          fill="#003399"
        />
        <path
          d="M46.6728 59.5411C52.4019 59.5411 56.6534 57.2986 59.6085 53.6349L54.4672 49.0855C51.9872 51.3883 49.8011 52.3345 46.7896 52.3345C42.7756 52.3345 39.9373 50.2087 39.0516 46.1344H61.082C61.1384 45.305 61.1987 44.4797 61.1987 43.7711C61.1987 34.7931 56.3554 26.584 45.7831 26.584C36.5715 26.584 30.1299 34.0241 30.1299 43.0625C30.1299 52.8659 37.1593 59.5411 46.6688 59.5411M38.9348 40.5221C39.6434 36.4478 42.0671 33.7906 45.7871 33.7906C49.5072 33.7906 51.9308 36.5081 52.4623 40.5221H38.9348Z"
          fill="#003399"
        />
        <path
          d="M3.63449 58.8326H28.5113V51.5696H12.0247L26.8325 35.2722C27.9195 34.0765 29.3568 32.7036 29.3568 30.9523V30.6624C29.3568 29.7606 29.0105 28.9353 28.4429 28.3153C27.7142 27.4779 26.8284 27.2001 25.8702 27.1719H1.52083V34.4389H17.2787L4.07333 49.0252C2.6763 50.5671 0.147949 52.7291 0.147949 55.0521V55.342C0.147949 57.3953 1.64966 58.6796 3.63449 58.8285"
          fill="#003399"
        />
        <path
          d="M168.142 51.8394C173.674 54.9515 179.725 65.2581 179.367 74.7797C179.133 80.9475 174.318 86.0042 168.142 86.0042C161.966 86.0042 157.151 80.9475 156.918 74.7797C156.559 65.2581 162.61 54.9515 168.142 51.8394Z"
          fill="#E31E24"
        />
        <path
          d="M175.796 38.5813C181.259 41.8142 193.208 41.9028 201.276 36.83C206.502 33.5448 208.471 26.8455 205.383 21.4989C202.295 16.1523 195.511 14.5057 190.052 17.3883C181.625 21.8371 175.727 32.2323 175.796 38.5773"
          fill="#FFED00"
        />
        <path
          d="M166.636 37.3815C169.74 36.5521 172.929 38.392 173.762 41.4961C174.592 44.6002 172.752 47.7888 169.648 48.6222C166.544 49.4556 163.355 47.6116 162.522 44.5076C161.688 41.4035 163.532 38.2149 166.636 37.3815Z"
          fill="#003399"
        />
        <path
          d="M168.142 34.1649C173.674 31.0528 179.725 20.7461 179.367 11.2246C179.133 5.05669 174.318 0 168.142 0C161.966 0 157.151 5.05669 156.918 11.2246C156.559 20.7461 162.61 31.0528 168.142 34.1649Z"
          fill="#009846"
        />
        <path
          d="M175.796 47.4189C175.723 53.7639 181.625 64.1591 190.052 68.6079C195.511 71.4905 202.299 69.8479 205.383 64.5013C208.471 59.1548 206.498 52.4554 201.272 49.1702C193.208 44.0974 181.255 44.186 175.792 47.4189"
          fill="#EF7F1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_24656_7342">
          <rect
            width="206.704"
            height="86"
            fill="white"
            transform="translate(0.147949)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
